import React, { useContext, useEffect, useState, useRef } from "react";
import AxioInstance from "../../axios/AxiosConfig";
import { AuthContext } from "../../context/AuthContext";
import { FormatAmount } from "../../containers/common/functions";
import { data } from "node-persist";
import { useHistory } from 'react-router-dom';
import { ModalPassword } from "../modals/ModalPassword";

const CardCreation = (props) => {
    console.log("🚀 ~ CardCreation ~ props:", props)
    const history = useHistory();
    const [amountInput, setAmountInput] = useState("200");
    const [estimates, setEstimates] = useState(null);
    const [loadingCreation, setLoadingCreation] = useState(false);
    const [loadingEstimates, setLoadingEstimates] = useState(false);
    const { getAuthenticatedHeaders, userDetailsContext } = useContext(AuthContext)
    const [showModalPassword, setShowModalPassword] = useState(false);
    const [error, setError] = useState(null);
    const [errorCreation, setErrorCreation] = useState(null);
    const [trm, setTrm] = useState(0);
    const [showDescripcion, setshowDescripcion] = useState(false)
    const [card_name, setCard_name] = useState('')
    const inputDescripcionRef = useRef(null);
    // Referencia para el temporizador de debounce
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (showDescripcion && inputDescripcionRef.current) {
            inputDescripcionRef.current.focus();
        }
    }, [showDescripcion]);

    const handleBack = () => {
        // Manejar la navegación hacia atrás
        console.log("Back pressed");
    };

    const handleListNavigation = () => {
        // Navegar a la lista de tarjetas
        console.log("Navigate to card list");
    };

    const handleAmountChange = (value) => {
        // Formatear el número ingresado
        setAmountInput(value);
    };

    const handleCreation = async () => {
        // Lógica para crear tarjeta
        try {
            setLoadingCreation(true)
            const body = {
                amount: estimates?.USD,
                card_name,
                headers: await getAuthenticatedHeaders(),
            }
            const respCreation = await AxioInstance.post('/api/create_and_reaload_card', body)
            if (respCreation?.data?.status !== 200) {
                if (respCreation.data?.data?.message) {
                    console.log(respCreation.data?.data?.message)
                    setErrorCreation(respCreation.data?.data?.message)
                } else {
                    console.log('Error inesperado')
                    setErrorCreation('Error inesperado')
                }
            } else {
                const cardInfo = {
                    showCreditCard: true,
                    franchise: 'Visa',
                    estimates,
                    craeditCard: respCreation.data?.data?.card.masked_pan /* .toString().slice(creditCardNumber.length-4, creditCardNumber.length) */,
                    balanceCard: respCreation.data?.data?.card.balance,
                    card: respCreation.data?.data?.card
                }

                history.push('/tarjetas/detalle', { ...cardInfo.card, card_id: cardInfo.card?.card_id ? cardInfo.card?.card_id : cardInfo.card?.id });
            }
            setLoadingCreation(false)
        } catch (error) {
            setLoadingCreation(false)
        }
    };
    const CalculateCost = async () => {
        try {
            setLoadingEstimates(true)
            const respTrm = await AxioInstance.post('/api/estimates/card', {
                amount: null,
                is_created: null,
                headers: await getAuthenticatedHeaders(),

            })
            console.log("🚀 ~ CalculateCost ~ respTrm:", respTrm)
            const trm = respTrm?.data?.data?.result?.spot
            /*             console.log("🚀 ~ CalculateCost ~ respTrm:", trm)
             */
            const amountInCop = parseInt(amountInput)

            const respEstimates = await AxioInstance.post('/api/estimates/card', {
                amount: amountInCop,
                is_created: true,
                headers: await getAuthenticatedHeaders(),

            })
            const estimates = respEstimates?.data?.data?.result
            setEstimates(estimates)
            console.log("🚀 ~ CalculateCost ~ estimates:", estimates)
        } catch (error) {
            console.log(error);

        } finally {
            setLoadingEstimates(false)
        }
    }
    useEffect(() => {
        CalculateCost()
    }, [])

    // Efecto para ejecutar CalculateCost cuando amountInput cambie (con debounce)
    useEffect(() => {
        if (amountInput) {
            // Limpia el temporizador anterior si existe
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            // Establece un nuevo temporizador que ejecutará CalculateCost después de 800ms
            timeoutRef.current = setTimeout(() => {
                CalculateCost();
            }, 800);
        }

        // Limpia el temporizador cuando el componente se desmonte o amountInput cambie
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [amountInput]);

    const checkUserPassword = async (password) => {
        handleCreation()


    };

    useEffect(() => {
        getTrm()
    }, [])
    const getTrm = async () => {
        const respTrm = await AxioInstance.post('/api/price_trm', {
            headers: await getAuthenticatedHeaders(),
        })
        setTrm(respTrm?.data?.data?.price)
        console.log("🚀 ~ getTrm ~ respTrm:", respTrm)
    }
    return (
        <>
            {
                showModalPassword && (
                    <ModalPassword
                        handleOK={checkUserPassword}
                        handleCancel={() => {
                            setShowModalPassword(false)
                        }}
                        error={error}
                    />
                )
            }
            <div className="min-h-screen flex flex-col justify-center items-center">
                {/* Header */}


                {/* Content */}
                <div className="flex-1 overflow-y-auto p-4 max-w-sm w-full">
                    <h1 className="text-center font-bold text-xl">Crear Tarjeta</h1>
                    <p className="text-center text-gray-600 my-4">Tipo de tarjeta</p>

                    {/* Card Type */}
                    <div className="bg-white rounded-lg p-4 flex justify-between items-center mb-6">
                        <span className="text-gray-800 font-medium">Tarjeta Prepagada</span>
                        <img
                            src={require('../../assets/card/VISA.png')}
                            alt="VISA"
                            className="w-16 h-auto"
                        />
                    </div>

                    {/* Card Balance */}
                    <p className="text-center text-gray-600 mb-2">Saldo de la Tarjeta</p>
                    <div className="bg-white rounded-lg p-4 flex items-center">
                        <input
                            type="number"
                            value={amountInput}
                            onChange={(e) => handleAmountChange(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    CalculateCost();
                                }
                            }}
                            placeholder="Ingrese el monto"
                            className="flex-1 text-gray-800 border-none focus:outline-none"
                        />
                        {loadingEstimates && (
                            <div className="ml-2 flex-shrink-0">
                                <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-blue-500"></div>
                            </div>
                        )}
                        <span className="ml-2 text-gray-600">USD</span>
                    </div>

                    <div className="flex items-center justify-between mb-4 px-2">
                        <p className="text-sm text-gray-500">
                            1 USD ~ {trm ? FormatAmount(Math.floor(trm) || "", 1) : 0}
                        </p>

                    </div>

                    {showDescripcion ? (
                        <div className="bg-white rounded-lg p-4 flex items-center mb-6">
                            <input

                                ref={inputDescripcionRef}
                                value={card_name}
                                onChange={(e) => setCard_name(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        CalculateCost();
                                    }
                                }}
                                placeholder="Descripción"
                                className="flex-1 text-gray-800 border-none focus:outline-none"
                            />
                        </div>
                    ) : (
                        <p
                            onClick={() => {
                                setshowDescripcion(true);
                            }}
                            className="text-center text-blue-500 underline cursor-pointer mb-2"
                        >
                            Agregar descripción
                        </p>
                    )}
                    {/* Summary */}
                    {estimates && (
                        <div className="bg-white rounded-lg p-4 mb-4">
                            <div className="flex justify-between mb-2">
                                <span className="font-bold text-gray-800">Monto a Debitar</span>
                                <span className="font-bold text-gray-800">
                                    {FormatAmount(parseInt(estimates?.debit_COP) || "", 1)}
                                </span>
                            </div>
                            <div className="flex justify-between text-gray-600 mb-2">
                                <span>Comisión de creación</span>
                                <span>{FormatAmount(parseInt(estimates?.fee) || "", 1)}</span>
                            </div>
                            <div className="flex justify-between text-gray-600 mb-2">
                                <span>IVA de Comisión</span>
                                <span>{FormatAmount(parseInt(estimates?.vat) || "", 1)}</span>
                            </div>
                            <div className="flex justify-between font-bold text-gray-800">
                                <span>Saldo en tarjeta</span>
                                <span>{FormatAmount(parseInt(estimates?.USD) || "", 1)} USD</span>
                            </div>
                        </div>
                    )}
                    {errorCreation &&
                        <span className="text-red-500 text-xs italic mb-4 flex justify-center">{errorCreation}</span>
                    }
                    {/* Action Button */}
                    <button
                        onClick={handleCreation}
                        disabled={!estimates || loadingCreation}
                        className={`${loadingCreation || !estimates ? 'bg-gray-400' : 'bg-blue-600'} text-white disabled:bg-gray-400 active:bg-blue-600 font-bold uppercase text-sm px-6 py-3 rounded hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 rounded-full w-full`}
                    >
                        {loadingCreation ? "Cargando..." : `Pagar ${FormatAmount(parseInt(estimates?.debit_COP) || "", 1)}`}
                    </button>
                </div>
            </div>
        </>

    );
};

export default CardCreation;
